import type { HeightUnit, WeightUnit } from "./types";

export const LB_PER_KG = 2.2046226218;
export const IN_PER_CM = 0.3937007874;

export function lbsToKg(lbs: number): number {
  return lbs / LB_PER_KG;
}

export function kgToLbs(kg: number): number {
  return kg * LB_PER_KG;
}

export function inToCm(inches: number): number {
  return inches / IN_PER_CM;
}

export function cmToIn(cm: number): number {
  return cm * IN_PER_CM;
}

export function displayWeight(lbs: number, unit: WeightUnit): number {
  const v = unit === "lb" ? lbs : lbsToKg(lbs);
  return Math.round(v * 10) / 10;
}

export function parseWeightToLbs(value: number, unit: WeightUnit): number {
  return unit === "lb" ? value : kgToLbs(value);
}

export function displayHeight(
  inches: number,
  unit: HeightUnit,
): { ft: number; inches: number; cm: number } {
  const totalIn = inches;
  const ft = Math.floor(totalIn / 12);
  const remIn = Math.round((totalIn - ft * 12) * 10) / 10;
  return { ft, inches: remIn, cm: Math.round(inToCm(totalIn)) };
}

export function weightStep(unit: WeightUnit): number {
  return unit === "lb" ? 1 : 0.5;
}

export function weightMin(unit: WeightUnit): number {
  return unit === "lb" ? 70 : 30;
}

export function weightMax(unit: WeightUnit): number {
  return unit === "lb" ? 450 : 200;
}
